export const riskTone = (value) => {
  const score = Math.round(value || 0);

  if (score >= 70) return "danger";
  if (score >= 40) return "gold";
  if (score >= 20) return "teal";

  return "success";
};

export const impactTone = (value) => {
  if (value === "CRITICAL") return "danger";
  if (value === "HIGH") return "gold";
  if (value === "MEDIUM") return "teal";
  if (value === "LOW") return "success";

  return "default";
};

export const priorityTone = impactTone;

export const countRiskTone = (value) => {
  return Number(value || 0) > 0 ? "gold" : "success";
};

export const countDangerTone = (value) => {
  return Number(value || 0) > 0 ? "danger" : "success";
};

export const coverageTone = (value) => {
  const score = Math.round(value || 0);

  if (score >= 90) return "success";
  if (score >= 60) return "gold";
  if (score >= 30) return "teal";

  return "danger";
};

export const knowledgeStatusTone = (status) => {
  const map = {
    Complete: "success",
    "In progress": "teal",
    "Attention needed": "gold",
    "Review required": "gold",
    "Not started": "danger",
  };

  return map[status] || "default";
};

export const gapStatusTone = (status) => {
  const map = {
    "Missing people": "gold",
    "Missing SOPs": "teal",
    "Missing people and SOPs": "danger",
  };

  return map[status] || "default";
};

// Staff SOPs view

export const sopStatusTone = (status) => {
  const map = {
    ACTIVE: "success",
    APPROVED: "success",
    PENDING: "gold",
    PENDING_APPROVAL: "gold",
    IN_REVIEW: "gold",
    DRAFT: "default",
    REJECTED: "danger",
    ARCHIVED: "default",
  };

  return map[status] || "default";
};

// Approvals

export const approvalStatusTone = (status) => {
  const map = {
    PENDING: "gold",
    PENDING_APPROVAL: "gold",
    APPROVED: "success",
    REJECTED: "danger",
  };

  return map[status] || "default";
};

// Learning journey

export const learningStatusTone = (status) => {
  const map = {
    Complete: "success",
    Understood: "success",
    Approved: "success",
    Read: "teal",
    Pending: "gold",
    "Not started": "danger",
    Rejected: "danger",
  };

  return map[status] || "default";
};

export const nextActionTone = (action) => {
  const map = {
    Complete: "success",
    "Read SOP": "teal",
    "Mark Understood": "gold",
    "Awaiting Approval": "default",
    "Review Required": "danger",
  };

  return map[action] || "default";
};

export const achievementTone = (unlocked) => {
  return unlocked ? "success" : "default";
};

// Relationships

export const contactStatusTone = (status) => {
  const map = {
    TARGETED: "default",
    MET: "teal",
    DEVELOPING: "teal",
    TRUSTED: "success",
    OPPORTUNITY: "gold",
    PROPOSAL: "gold",
    CLIENT: "success",
    FORMER_CLIENT: "default",
    DORMANT: "default",
    ARCHIVED: "default",
  };

  return map[status] || "default";
};

export const engagementTone = (level) => {
  const map = {
    COLD: "default",
    OBSERVING: "teal",
    LIGHTLY_ENGAGED: "teal",
    ENGAGED: "gold",
    ACTIVE: "success",
  };

  return map[level] || "default";
};

export const fitScoreTone = (score) => {
  if (score >= 5) return "success";
  if (score >= 4) return "teal";
  if (score >= 3) return "gold";

  return "default";
};

export const relationshipScoreTone = (score) => {
  const numericScore = Number(score || 0);

  if (numericScore > 70) return "success";
  if (numericScore > 40) return "gold";
  if (numericScore > 0) return "teal";

  return "default";
};

export const followUpTone = (date) => {
  if (!date) return "default";

  return new Date(date) < new Date()
    ? "danger"
    : "default";
};

// Projects

export const projectStatusTone = (status) => {
  const map = {
    NOT_STARTED: "default",
    DRAFT: "default",
    IN_PROGRESS: "teal",
    BLOCKED: "danger",
    ON_HOLD: "gold",
    COMPLETED: "success",
    DONE: "success",
    CANCELLED: "default",
    ARCHIVED: "default",
  };

  return map[status] || "default";
};

/*
 * This function still returns MUI Chip props and is retained for existing
 * consumers that have not yet migrated to the shared StatusChip component.
 */
export const getProgressChipProps = (status) => {
  switch (status) {
    case "UNDERSTOOD":
      return {
        label: "✓ Understood",
        color: "success",
        variant: "filled",
      };

    case "UPDATED":
      return {
        label: "Updated",
        color: "warning",
        variant: "filled",
      };

    case "READ":
      return {
        label: "Read",
        color: "info",
        variant: "filled",
      };

    case "NEW":
    default:
      return {
        label: "New",
        color: "default",
        variant: "filled",
      };
  }
};

// Audits

export const auditStatusTone = (status) => {
  const map = {
    DRAFT: "default",
    IN_PROGRESS: "gold",
    COMPLETED: "success",
    ARCHIVED: "default",
  };

  return map[status] || "default";
};

// Role resourcing and coverage

export const coverageStatusTone = (status) => {
  const map = {
    COVERED: "success",
    TEMPORARILY_COVERED: "gold",
    VACANT: "danger",
  };

  return map[status] || "default";
};

export const resourcingTypeTone = (type) => {
  const map = {
    EXTERNAL: "teal",
    INTERNAL: "default",
  };

  return map[type] || "default";
};

// Operational resilience

export const resilienceTone = (value) => {
  const score = Number(value || 0);

  if (score >= 70) return "success";
  if (score >= 40) return "gold";

  return "danger";
};

export const booleanRiskTone = (value) => {
  return value ? "danger" : "default";
};